import { defaultTheme } from 'gd-design-library';
import { colors } from './colors';
import { font } from './font';

export const button = {
  ...defaultTheme.button,
  default: {
    ...defaultTheme.button.default,
    fontFamily: font.family,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0.64px',
    textTransform: 'uppercase',
    padding: '8px 24px',
    minWidth: '64px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  primary: {
    ...defaultTheme.button.primary,
    background: colors.primary.default,
    color: colors.neutral.white,
    '&:hover': {
      background: colors.primary['default.80'],
      color: colors.neutral.white
    },
    '&:disabled': {
      background: colors.primary['default.10']
    }
  },
  outlined: {
    ...defaultTheme.button.outlined,
    color: colors.primary.default,
    background: colors.neutral.white,
    border: 'none',
    boxShadow: `inset 0 0 0 1px ${colors.neutral['grey.100']}`,
    '&:hover': {
      color: colors.primary.default
    },
    '&:disabled': {
      boxShadow: `inset 0 0 0 1px ${colors.neutral['grey.20']}`
    }
  },
  text: {
    ...defaultTheme.button.text,
    color: colors.primary.default,
    background: 'transparent',
    '&:hover': {
      background: colors.primary['default.10'],
      color: colors.primary.default
    },
    '&:disabled': {
      background: 'transparent',
      color: colors.neutral['grey.40']
    }
  },
  inherit: {
    ...defaultTheme.button.inherit,
    color: colors.primary.default,
    padding: '0',
    backgroundColor: 'transparent',
    '&:hover': {
      background: colors.primary['default.10'],
      color: colors.primary.default
    },
    '&:disabled': {
      background: 'transparent',
      color: colors.neutral['grey.40']
    }
  },
  startIcon: {
    ...defaultTheme.button.startIcon,
    'default': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  endIcon: {
    ...defaultTheme.button.endIcon,
    'default': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      'div': {
        display: 'flex',
        alignItems: 'center'
      }
    }
  },
  content: {
    ...defaultTheme.button.content,
    default: {
      ...defaultTheme.button.content.default,
      width: 'auto'
    }
  },
  icon: {
    ...defaultTheme.button.icon,
    minWidth: 'auto'
  }
};
